import { MediaType, MediaQuality } from '@signage-player/data-store';
import { BrowserPlayer, PlayerManager, WebIframePlayer } from '@signage-player/player';
import {
  BroadcastInterface,
  LoggerInterface,
  MediaControlInterface,
  PlayerManagerFactoryInterface,
} from '@signage-player/contracts';

export class WebPlayerManagerFactory implements PlayerManagerFactoryInterface {
  constructor(
    private desiredVideoQuality: MediaQuality,
    private broadcast: BroadcastInterface,
    private logger: LoggerInterface,
    private mediaControl: MediaControlInterface
  ) {}

  public createForDisplay(displayId: number): PlayerManager {
    const manager = new PlayerManager(this.desiredVideoQuality, this.logger);
    const browserPlayer = new BrowserPlayer(this.desiredVideoQuality, this.logger, this.broadcast, this.mediaControl);
    manager.registerPlayer(MediaType.AUDIO, browserPlayer);
    manager.registerPlayer(MediaType.IMAGE, browserPlayer);
    manager.registerPlayer(MediaType.VIDEO, browserPlayer);
    manager.registerPlayer(
      MediaType.WEB,
      new WebIframePlayer(this.desiredVideoQuality, this.logger, this.broadcast, this.mediaControl)
    );
    this.logger.debug('[WebPlayerManagerFactory] Created player manager for display', { displayId });
    return manager;
  }
}

export default WebPlayerManagerFactory;
